import _ from 'lodash'
import { GetterTree } from 'vuex'

import { CartScopeEq } from '@/models/cart/group/scope'
import { OrderHistoryApiService } from '@spa/services/api/orderHistory'
import { OrderHistoryQueryBuilder } from '@spa/services/api/orderHistory/query-builder'
import { OrderHistoryService } from '@spa/services/orderHistory'
import { RootState } from '../../types'
import { allItems } from './functions/page'
import {
  convertToOrder,
  convertToProducts,
  Order,
  OrderHistoryState,
} from './types'

export const getters: GetterTree<OrderHistoryState, RootState> = {
  hasError(state): boolean {
    return _.has(state, 'error.error')
  },

  getError(state): Error {
    return _.get(state, 'error.error')
  },

  allItems(state): Order[] {
    return allItems(state.pages)
  },

  getItem(state): (string) => Order | undefined {
    return (id: string) => {
      return _.find(allItems(state.pages), ['id', id])
    }
  },

  /**
   * TODO:
   * データの取得・変換の手続きがactionsのgetと大部分で一致しているので共通化したい
   * というより手続き的に行っている処理をドメインモデル化しrepository内部に閉じるように修正したい
   */
  getLatest: () =>
    async (scope?: CartScopeEq): Promise<Order | undefined> => {
      const orderHistoryApiService = new OrderHistoryApiService()
      const result = await orderHistoryApiService.list(
        OrderHistoryQueryBuilder.empty()
          .withMaybeCartScope(scope)
          .withLimit(1)
          .toObject()
      )

      if (result.isLeft()) {
        return Promise.reject(result.value)
      }

      const head = result.value.body.data[0]
      if (!head) {
        return Promise.reject('no order history')
      }

      const order = convertToOrder(head)

      try {
        const rawOrder = head
        const joined = await orderHistoryApiService.join(rawOrder.item)
        const products = convertToProducts(rawOrder.item)
        order.products = await new OrderHistoryService().injectWithJoinedProductInfo(products, joined)
        order.isFreeShippingOnCatalogOnly = _.every(order.products, p => p.isCatalogType)

        return order
      } catch (error) {
        return Promise.reject(error)
      }
    },
}
